import quickBIViewer from './_src/quickBIViewer.vue'
quickBIViewer.install = function(Vue) {
  Vue.component(quickBIViewer.name, quickBIViewer)
}

export default quickBIViewer